import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import timeFast from '../../../assets/production-flow/time-fast.svg';
import pcp from '../../../assets/production-flow/pcp.svg';
import filter from '../../../assets/stock/TableMovementHeader/filter.svg';
import { LeftSide, SectionName, SubHeaderContainer, TabsDiv, Tab, RightSide } from '../../../components/styles/subheader-style';
import { FilterDiv, FilterImg, FilterText, Content, Select, NewOPButton } from './style';
import ModalContext from '../../../contexts/ModalContext';

type PCPViewType = 'table' | 'board';

export interface ProductionFashionOutletType {
    tabIndex: number;
    setTabIndex: React.Dispatch<React.SetStateAction<number>>;
    pcpView: PCPViewType;
    setPCPView: React.Dispatch<React.SetStateAction<PCPViewType>>;
}

const TAB_INDEX_ORDEM_PRODUCAO = 0;
const TAB_INDEX_PCP = 1;

const tabs = [
    { path: '', image: timeFast, name: 'Ordem de produção', index: TAB_INDEX_ORDEM_PRODUCAO },
    { path: 'pcp', image: pcp, name: 'PCP', index: TAB_INDEX_PCP }
];

const ProductionFashionSubHeader: React.FC<{
    tabIndexActived: number;
    pcpView: PCPViewType;
    setPCPView: React.Dispatch<React.SetStateAction<PCPViewType>>;
    onAddOPClick: () => void;
}> = ({ tabIndexActived, pcpView, setPCPView, onAddOPClick }) => {
    const navigate = useNavigate();

    const isOrdemProducaoTab = tabIndexActived === TAB_INDEX_ORDEM_PRODUCAO;
    const isPCPTab = tabIndexActived === TAB_INDEX_PCP;
    const { setModalActive, setModalSection } = useContext(ModalContext)

    const addFashionOP = () => {
        setModalActive(true)
        setModalSection('addFashionOP')
    }

    return (
        <SubHeaderContainer>
            <LeftSide>
                <SectionName>
                    Produção
                </SectionName>
                <TabsDiv>
                    {tabs.map((tab, index) => (
                        <Tab
                            key={index}
                            $isFirst={index === 0}
                            $isLast={index === tabs.length - 1}
                            $isActive={index === tabIndexActived}
                            onClick={() => {
                                if (index !== tabIndexActived) navigate(tab.path);
                            }}
                        >
                            <img src={tab.image} alt={`${tab.path}-icon`} />
                            {tab.name}
                        </Tab>
                    ))}
                </TabsDiv>
            </LeftSide>
            <RightSide>
                {isOrdemProducaoTab && (
                    <FilterDiv>
                        <FilterImg src={filter} alt='filter-icon' />
                        <FilterText>Filtrar</FilterText>
                    </FilterDiv>
                )}

                {isPCPTab && (
                    <>
                        <span>Visualizar por</span>
                        <Select
                            value={pcpView}
                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setPCPView(e.target.value as PCPViewType)}
                        >
                            <option value="table">Tabela</option>
                            <option value="board">Quadro</option>
                        </Select>

                        <NewOPButton onClick={onAddOPClick}>
                            + Adicionar OP
                        </NewOPButton>
                    </>
                )}
            </RightSide>
        </SubHeaderContainer>
    );
};

const ProductionFashionContent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState<number>(TAB_INDEX_ORDEM_PRODUCAO);
    const [pcpView, setPCPView] = useState<PCPViewType>('table');

    const handleAddOPClick = useCallback(() => {
        console.log('🔘 Botão Adicionar OP clicado');
        console.log('📍 Location atual:', location.pathname);
        navigate('/panel/production-fashion/pcp/create');
        console.log('✅ Navigate executado para: /panel/production-fashion/pcp/create');
    }, [navigate, location.pathname]);

    useEffect(() => {
        const pathSegment = location.pathname.split('/').pop();
        const currentTabIndex = tabs.findIndex(tab => tab.path === pathSegment);

        if (currentTabIndex !== -1 && currentTabIndex !== tabIndex) {
            setTabIndex(currentTabIndex);
        } else if (pathSegment === 'production-fashion' && tabIndex !== TAB_INDEX_ORDEM_PRODUCAO) {
            setTabIndex(TAB_INDEX_ORDEM_PRODUCAO);
        }
    }, [location.pathname, tabIndex]);

    return (
        <>
            <ProductionFashionSubHeader
                tabIndexActived={tabIndex}
                pcpView={pcpView}
                setPCPView={setPCPView}
                onAddOPClick={handleAddOPClick}
            />
            <Content>
                <Outlet
                    context={{
                        tabIndex,
                        setTabIndex,
                        pcpView,
                        setPCPView
                    }}
                />
            </Content>
        </>
    );
};

export default ProductionFashionContent;